export enum NEW_PATIENT_FORM_KEYS {
  ID = 'id',
  NAME = 'name',
  FIRST_NAME = 'first_name',
  LAST_NAME = 'last_name',
  ROOM = 'room',
  APPOINTMENT = 'appointment',
  PHONE = 'phone',
  WORK_PHONE = 'work_phone',
  HOME_PHONE = 'home_phone',
  LANGUAGE = 'language',
  LANGUAGE_TYPE_CODE = 'language_type_code',
  CONSULTATION_STAFF = 'consultation_staff',
  TEMPERATURE_BYPASS = 'temperature_bypass',
  PROCEDURE = 'procedure',
  CATEGORY_TYPE_CODE = 'category_type_code',
  TITLE = 'title',
  TIME = 'time',
  DURATION = 'duration',
  DATE = 'date',
  COMMENTS = 'comments',
  PATIENT_STATUS = 'patient_status',
  PUNCTUALITY_TYPE_CODE = 'punctuality_type_code',
  PUNCTUALITY_MINUTES = 'punctuality_minutes',
  PATIENT_PUNCTUALITY = 'patient_punctuality',
}

export const INITIAL_PATIENT_DATA = {
  id: '',
  // name: '',
  room: '',
  appointment: '',
  phone: '',
  language: '',
  language_type_code: 1,
  consultation_staff: '',
  temperature_bypass: 0,
  procedure: {
    code: '',
    description: '',
  },
  category: '',
  category_type_code: '',
  title: '',
  comments: '',
  patient_status: '',
}

export const EHR_INITIAL_PATIENT_DATA = {
  id: '',
  room: '',
  appointment: '',
  phone: '',
  language: '',
  language_type_code: 1,
  consultation_staff: '',
  temperature_bypass: 0,
  comments: '',
  patient_status: '',
}
